<div class="flex-wrapper">
  <button mat-button (click)="openDialog()">
    <mat-icon>add</mat-icon>
    Add File
  </button>
</div>
<div class="flex-wrapper pt-2" *ngIf="fileList.length > 0">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef> File Name </th>
      <td mat-cell *matCellDef="let file"> {{file.fileName}} </td>
    </ng-container>

    <ng-container matColumnDef="fileDescription">
      <th mat-header-cell *matHeaderCellDef> File Description </th>
      <td mat-cell *matCellDef="let file"> {{file.description}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let file">
        <button mat-icon-button (click)="removeFile(file.documentId)"  aria-label="Remove file">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
